import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import atoms from "../../../styles/atoms.module.scss.js";
import { useFooterContext } from "../Footer.js";
import styles from "./SEOLinks.module.scss.js";
import { emitLinkClickEvent } from "../../../utils/tracking.js";
function Section(props) {
  const context = useFooterContext();
  const [isExpanded, setIsExpanded] = useState(false);
  return /* @__PURE__ */ jsxs("div", { className: styles.section, children: [
    /* @__PURE__ */ jsx("h2", { className: styles.heading, children: props.heading }),
    /* @__PURE__ */ jsx("ul", { className: styles.list, children: props.links.map((link, index) => /* @__PURE__ */ jsx(
      "li",
      {
        className: !isExpanded && index > 4 ? atoms.hidden : "",
        children: /* @__PURE__ */ jsx(
          "a",
          {
            className: styles.link,
            href: context.resolveURL(link.url),
            onClick: (e) => {
              emitLinkClickEvent(e, {
                interaction_name: "footer_seo_link_click"
              });
            },
            ...link.openInNewTab && {
              target: "_blank",
              rel: "noreferrer"
            },
            children: link.label
          }
        )
      },
      link.label
    )) }),
    props.links.length > 5 && /* @__PURE__ */ jsxs(
      "button",
      {
        className: styles.button,
        onClick: () => setIsExpanded(!isExpanded),
        children: [
          "Show ",
          isExpanded ? "less" : "more"
        ]
      }
    )
  ] });
}
function SEOLinks(props) {
  return /* @__PURE__ */ jsx("div", { className: styles.root, children: props.sections.map((section) => /* @__PURE__ */ jsx(Section, { ...section }, section.heading)) });
}
export {
  SEOLinks
};
